import * as React from 'react';
import { useRef, useEffect } from 'react';
import SliderSlick, { Settings } from 'react-slick';

import { PassengerState } from '../../../../Checkout/store/passengers/reducers';

interface Props {
	settings?: Settings;
	passengers: PassengerState[];
	segmentId: string;
	passengerId: string;
	forceGoToSliderStart?: number;
}

const Slider: React.FC<Props> = ({ children, settings, passengers, segmentId, passengerId, forceGoToSliderStart }) => {
	const sliderRef = useRef<SliderSlick>();

	useEffect(() => {
		if (sliderRef.current) {
			setTimeout(() => sliderRef.current?.slickGoTo?.(0));
		}
	}, [sliderRef.current, segmentId]);

	useEffect(() => {
		if (sliderRef.current) {
			const passengerIndex = passengers.findIndex(passenger => passenger.id === passengerId);

			setTimeout(() => sliderRef.current?.slickGoTo?.(passengerIndex));
		}
	}, [sliderRef.current, passengers, passengerId, forceGoToSliderStart]);

	return (
		<SliderSlick {...settings} ref={sliderRef}>
			{children}
		</SliderSlick>
	);
};

export default Slider;
